import { categories, categoryArticles, featuredColumn } from "@/mocks/media";

export default function DeepSection() {
  return (
    <section id="deep" className="scroll-mt-20 py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">FEATURED</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">深度专题与精选</h2>
          </div>
          <p className="text-sm text-foreground-500">编辑部严选 · 值得慢读的行业内容</p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <article className="lg:col-span-2 rounded-2xl overflow-hidden bg-foreground-950 relative min-h-[360px] flex flex-col justify-end">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=theater%20stage%20curtains%20opening%20with%20warm%20spotlight%20beams%20and%20film%20crew%20silhouettes%2C%20dramatic%20cinematic%20editorial%20photography%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20high%20detail&width=1600&height=900&seq=deep-feature-01&orientation=landscape"
                alt="给角色让路：演员如何重新定义专业"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
            <div className="relative p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-accent-950 text-xs font-bold">
                <i className="ri-fire-line"></i> 编辑部深读
              </span>
              <h3 className="mt-4 font-heading font-bold text-xl md:text-3xl leading-snug text-background-50">
                {featuredColumn.title}
              </h3>
              <p className="mt-3 text-sm text-background-100/85 leading-relaxed max-w-2xl line-clamp-3">
                {featuredColumn.excerpt}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-background-100/70">
                <span className="inline-flex items-center gap-1.5"><i className="ri-user-3-line"></i>{featuredColumn.author}</span>
                <span>{featuredColumn.time}</span>
                <span className="inline-flex items-center gap-1.5"><i className="ri-eye-line"></i>{featuredColumn.reads}</span>
                <span className="ml-auto inline-flex items-center gap-1.5 text-accent-300">
                  展开阅读 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </article>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
            {categories.slice(0, 3).map((c) => {
              const top = categoryArticles[c.key]?.[0];
              return (
                <a
                  key={c.key}
                  href={`#${c.key}`}
                  className="group flex items-center gap-4 p-4 rounded-lg border border-background-200 bg-background-100 hover:bg-background-200"
                >
                  <span className="w-12 h-12 shrink-0 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-xl">
                    <i className={c.icon}></i>
                  </span>
                  <div className="min-w-0">
                    <p className="text-xs font-semibold text-primary-600">{c.name} · 最新</p>
                    <p className="mt-1 text-sm font-medium text-foreground-800 leading-snug group-hover:text-primary-600 line-clamp-2">
                      {top?.title}
                    </p>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}